<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/new-reimbursement/category-reimbursement"
              >Category Reimbursement</router-link
            ></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <form v-on:submit.prevent="doSubmit()">
          <b-row>
            <b-col md="4">
              <div class="form-group" v-bind:class="errors.has('name') ? 'has-error' : ''">
                <label class="labels">category name*</label>
                <b-form-input
                  v-model="model.categoryName"
                  v-bind:class="errors.has('name') ? 'is-invalid' : ''"
                  v-validate="'required'"
                  data-vv-as="name"
                  name="name"
                  placeholder="category name"
                  class="border-radius"
                />
                <p v-if="errors.has('name') !== null"></p>
              </div>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="4">
              <div>
                <label class="labels">Note</label>
                <b-form-textarea
                  class="border-radius"
                  v-model="model.categoryNote"
                  placeholder="Note"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <div>
                <label class="labels">account</label>
                <b-form-select v-model="model.journalAccount" :options="list.listAccount"></b-form-select>
              </div>
            </b-col>

            <b-col md="1"> </b-col>
            <b-col md="4" class="mt-4">
              <b-form-file
                placeholder="input icon"
                class="border-radius"
                v-model="model.categoryIcon"
                style="border-radius: 25px !important;"
                @change="previewImage"
              >
              </b-form-file>
              <template v-if="preview">
                  <img :src="preview" class="w-50 mt-2" />
              </template>
              <template v-else>
                 <img class="w-50 mt-2" v-if="model.picture" :src="model.picture" />
              </template>
            </b-col>
          </b-row>
          <b-button class="mt-3" @click="goBack()" variant="secondary"
            ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
          >
          <b-button type="submit" class="mt-3 float-right" variant="warning"
            ><font-awesome-icon icon="save"></font-awesome-icon> Save</b-button
          >
        </form>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      dataKey: 'reimbursement_category',
      apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
        reimbursementCategory: window.AppConfig.apiUrl + 'reimbursement-category',
      },
      model: {
        accountNameSelected: '',
        categoryName: '',
        categoryNote: '',
        journalAccount: '',
        categoryIcon: "",
        picture: null
      },
      list: {
        accountNameSelected: '',
        listAccount: [],
      },
      preview: '',
    };
  },

  mounted() {
    this.getAccountList();
    this.getDetail()
  },

  methods: {
    getAccountList() {
      this.$http.get(this.apiUrl.account + '?journalAccountType=D').then((response) => {
        response?.data?._embedded?.journal_account?.forEach((data) => {
          this.list.listAccount.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountName,
          });
        });
      });
    },

    doSubmit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('categoryName', this.model.categoryName);
          formData.append('journalAccount', this.model.journalAccount);
          formData.append('categoryNote', this.model.categoryNote);
          if(this.model.categoryIcon !=='') {
            formData.append('categoryIcon', this.model.categoryIcon);
          }
          this.$http.patch(this.apiUrl.reimbursementCategory + '/' + this.$route.params.uuid, formData).then(() => {
            this.$store.dispatch('notification/success', 'Reimbursement Category has been added!');
            window.location.href = document.URL.replace('/edit', '');
          }).catch(error => {
            this.$store.dispatch("notification/error", error)
          })
        } else {
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },

    getDetail() {
      this.$http
        .get(window.AppConfig.apiUrl + 'reimbursement-category' + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.categoryName = response.data.categoryName;
          // this.model.categoryIcon = response.data.categoryIcon;
          this.model.picture = response.data.categoryIcon;
          this.model.categoryNote = response.data.categoryNote;
          if (response.data.journalAccount !== null) {
            this.model.journalAccount = response.data.journalAccount.uuid;
            this.model.accountNameSelected = response.data.journalAccount.journalAccountName;
          }
        });
    },

     previewImage: function(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        }
        this.model.categoryIcon=input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },


    goBack() {
      window.goBack(this);
    },
  },
};
</script>
